module.exports = __webpack_public_path__ + "assets/devices/RP-600-PG2-555b7b4f3eb984153c1a3a5ab6ba33a8.svg";